const DashboardSection = () => {
    return (
        <div className="space-y-6">
            <h2 className="text-2xl font-bold text-slate-900">📊 Trang Chủ (Dashboard)</h2>
            <p className="text-slate-700">
                Dashboard là trang chủ của bạn, hiển thị tổng quan về quá trình học tập.
            </p>

            <div className="bg-white p-6 rounded-lg border border-slate-200">
                <h3 className="text-lg font-semibold text-slate-900 mb-4">Thông tin hiển thị:</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div className="p-4 bg-indigo-50 rounded-lg">
                        <h4 className="font-semibold text-indigo-900">📚 Lớp Học</h4>
                        <p className="text-sm text-slate-600">Danh sách các lớp bạn đang theo học với thông tin lịch học</p>
                    </div>
                    <div className="p-4 bg-green-50 rounded-lg">
                        <h4 className="font-semibold text-green-900">💰 Học Phí</h4>
                        <p className="text-sm text-slate-600">Theo dõi học phí đã nộp và còn nợ, thanh toán qua QR Code</p>
                    </div>
                    <div className="p-4 bg-purple-50 rounded-lg">
                        <h4 className="font-semibold text-purple-900">📅 Lịch Học</h4>
                        <p className="text-sm text-slate-600">Xem lịch học sắp tới và các sự kiện quan trọng</p>
                    </div>
                    <div className="p-4 bg-orange-50 rounded-lg">
                        <h4 className="font-semibold text-orange-900">📝 Bài Tập</h4>
                        <p className="text-sm text-slate-600">Danh sách bài tập cần làm và kết quả</p>
                    </div>
                    <div className="p-4 bg-blue-50 rounded-lg">
                        <h4 className="font-semibold text-blue-900">📊 Thống Kê</h4>
                        <p className="text-sm text-slate-600">Xem điểm số và tiến trình học tập của bạn</p>
                    </div>
                    <div className="p-4 bg-pink-50 rounded-lg">
                        <h4 className="font-semibold text-pink-900">📖 Bài Học Lý Thuyết</h4>
                        <p className="text-sm text-slate-600">Đọc các bài giảng và tài liệu học tập</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DashboardSection;
